export default __webpack_public_path__ + "static/media/logo-zad-02.3be86c4c.png";